import CheckboxInput from './components/CheckboxInput'
import PrescribeForm from './PrescribeForm'
import NewPatientForm from './NewPatientForm'
import EditPatientForm from './EditPatientForm'
import EditIDTFPatientForm from './EditIDTFPatientForm'
import EnrollmentForm from './EnrollmentForm'
import NewMemberForm from './NewMemberForm'
import CrpNewMemberForm from './CrpNewMemberForm'
import EditMemberForm from './EditMemberForm'
import UpdatePasswordForm from './UpdatePasswordForm'
import TkandCrpUpdatePasswordForm from './TkandCrpUpdatePasswordForm'
import InboxSettingsForm from './InboxSettingsForm'
import PatientDetailForm from './PatientDetail'
import TeamSettingsForm from './TeamSettingsForm'
import CrpTeamSettingsForm from './CrpTeamSettingsForm'

export {
  PrescribeForm,
  NewPatientForm,
  EditPatientForm,
  EditIDTFPatientForm,
  CheckboxInput,
  EnrollmentForm,
  NewMemberForm,
  CrpNewMemberForm,
  EditMemberForm,
  UpdatePasswordForm,
  TkandCrpUpdatePasswordForm,
  InboxSettingsForm,
  PatientDetailForm,
  TeamSettingsForm,
  CrpTeamSettingsForm,
}



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/index.js